import { CompanyUserStatisticQuery } from "@generated/graphql";
import { Grid, Typography } from "@mui/material";
import Card from "components/Card";

type TeamStatsProps = {
  statistic: CompanyUserStatisticQuery["companyUserStatistic"] | undefined;
  isLoading: boolean;
};

const TeamStats = ({ statistic, isLoading }: TeamStatsProps) => {
  const stats = [
    { label: "Всего в команде", value: statistic?.totalCount, color: "text.primary" },
    { label: "Активных", value: statistic?.activeCount, color: "green.contrast" },
    { label: "Ожидают активации", value: statistic?.pendingCount, color: "orange.contrast" },
    { label: "Деактивированных", value: statistic?.deactivatedCount, color: "text.disabled" },
  ];

  return (
    <Grid
      container
      gap={2}
      sx={{ flexDirection: { xs: "column", sm: "row" }, flexWrap: { xs: "wrap", md: "nowrap" } }}>
      {stats.map(({ label, value, color }) => (
        <Grid
          item
          xs={12}
          sm={6}
          md={3}
          key={label}>
          <Card>
            <Typography
              variant='h28'
              color={color}>
              {isLoading ? "-" : value}
            </Typography>
            <Typography color='text.secondary'>{label}</Typography>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default TeamStats;
